import hexToRgba from "../../util/hexToRgba";
import hexToRgb from "../../util/hexToRgb";
import hexLum from "../../util/hexLum";
import { Theme } from "./types";
import { darkMap } from "../GlobalStyles/google-maps";
import * as echarts from "echarts";
import fullscreenExpand from "../../imgs/fullscreen-expand-dark-theme.svg";
import fullscreenContract from "../../imgs/fullscreen-contract-dark-theme.svg";
import { checkDomain } from "../../util/checkDomain";

const DURATION = 250;

const theme: Theme = {
  space: [
    "4px",
    "8px",
    "12px",
    "16px",
    "24px",
    "32px",
    "48px",
    "64px",
    "96px",
    "128px",
    "192px",
    "256px",
    "384px",
    "512px",
    "640px",
    "768px",
    "896px",
    "1024px",
  ],
  color: {
    default: ["#505050"],
    primary: [checkDomain("#b8292f", "#1b75bb", "#814998", "#00b26b")],
    secondary: [checkDomain("#d5ae30", "#ee6c4d", "#deb81e", "#b27400")],
    success: ["#4bb543"],
    info: ["#d738ff"],
    warning: ["#e87900"],
    danger: ["#c90000"],

    success_dark: ["#086800"],
    danger_dark: ["#ae0000"],

    freshness: ["#ffdd00"],
    placeholder: ["#757575"],
    side_nav_inactive: ["#909090"],
    side_nav_active: ["#ffffff"],
    map_bg: ["#1f1f1f"],

    tooltip_bg: ["#222222"],
    tooltip_hover: ["#2c2c2c"],
    tooltip_success_hover: ["#087000"],
    tooltip_warning_hover: ["#e87900"],
    tooltip_danger_hover: ["#b60000"],
    tooltip_shadow: ["#00000066"],

    scroll_bar: ["#626262"],
    scroll_bar_hover: ["#4e4e4e"],

    border: ["#3f3f3f"],
    subtle_border: ["#383838"],

    more_hover: ["#2b2b2b"],

    modal_border: ["#343434"],
    modal_background: ["#1a1a1a"],
    modal_header_background: ["#222222"],

    dnd_list_item_bg: ["#121212"],
    react_icon_background: ["#262626"],

    other: ["#8D8E8F"],

    error: ["#ff0000"],
    font: ["#a9a9a9"],
    font_bold: ["#ffffff"],
    font_faint: ["#6e6e6e"],
    inverse_font: ["#3a3a3a"],
    inverse_font_bold: ["#000000"],
    inverse_font_faint: ["#aaaaaa"],
    button_font: ["#dddddd"],
    button_font_bold: ["#ffffff"],
    loading_bg: ["#000000"],
    loading_icon: ["#757575"],
    main_bg: ["#1f1f1f"],
    main_fg: ["#a9a9a9"],
    panel_bg: ["#242424"],
    panel_fg: ["#a9a9a9"],
    nearbyPlace: ["#7f00ff"],
    disabled: ["#666666"],
    table_group_header: ["#131313"],
    table_header: ["#1c1c1c"],
    table_border: ["#333333"],
    table_body: ["#1f1f1f"],
    shadow: ["#000000"],
    sign_in_bg: ["#000000"],
    cold: ["#0090ff"],
    warm: ["#ff8500"],
    hot: ["#ff0000"],
    great: ["#0b9300"],
    good: ["#8bb900"],
    average: ["#b9b300"],
    bad: ["#ffb800"],
    worse: ["#ff0000"],
    input_bg: ["#262626"],
    logo_beer_blue: ["#ffffff"],
    logo_beer_gray: ["#ffffff"],
    logo_tech_red: ["#ffffff"],
    logo_tech_gray: ["#ffffff"],
    logo_safari_green: ["#ffffff"],
    logo_safari_red: ["#ffffff"],
    logo_uas_blue: ["#ffffff"],
    logo_uas_gray: ["#ffffff"],
    logo_med_gray: ["#ffffff"],
    logo_med_plum: ["#ffffff"],
    logo_loop_gray: ["#ffffff"],
    logo_loop_green: ["#ffffff"],
  },
  color_80: {},
  color_50: {},
  color_30: {},
  color_15: {},
  color_rgb: {},
  fill_opacity: [0.1, 0.5, 0.9],
  stroke_width: [2, 1, 0.5],
  map_tile: "dark-v10",
  map_style: darkMap,
  filter_theme: "invert(77%) sepia(0%) saturate(0%) hue-rotate(141deg) brightness(87%) contrast(96%)",
  leaflet_fullscreen_expand: fullscreenExpand,
  leaflet_fullscreen_contract: fullscreenContract,
  sample_type_colors: {
    sample: "#0d85e1",
    historic: "#5415e4",
    userPrivate: "#ff4900",
    userPublic: "#f70046",
  },
  echarts_theme: "dark_theme",
  echarts_opacity: 0.2,
  echarts_palette: ["#0098d9", "#2b821d", "#c12e34", "#e6b600", "#005eaa", "#339ca8", "#cda819", "#32a487"],
  map_bg_grid:
    "url(data:image/png;base64,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)",
  short_datetime: "DD MMM Y HH:mm",
  long_datetime: "DD MMM Y HH:mm Z",
  short_date: "DD MMM Y",
  long_date: "ddd, Do MMM Y",
  time: "hh:mm a",
  maxWidth: {
    form: "25rem",
  },
  height: {
    toolbar: "48px",
  },
  fontFamily: {
    heading: "Montserrat, sans-serif",
    body: "Montserrat, sans-serif",
  },
  fontSize: {
    l: "1.25rem",
    m: "1rem",
    s: "0.85rem",
  },
  fontWeight: {
    bold: 500,
    medium: 400,
  },
  lineHeight: {
    l: 1.8,
    m: 1.5,
    s: 1,
  },
  letterSpacing: {
    s: "0.1em",
  },
  zIndex: {
    toolbar: 1,
  },
  opacity: {
    disabled: 0.35,
    placeholder: 0.35,
    fade: 0.35,
  },
  borderRadius: {
    m: "0.25rem",
  },
  /* https://codepen.io/protomorph/pen/VejmVE */
  dropShadow: {
    s: `
      drop-shadow(0 2px 2px rgba(0, 0, 0, 0.12))
      drop-shadow(0 3px 1px rgba(0, 0, 0, 0.14))
      drop-shadow(0 1px 5px rgba(0, 0, 0, 0.12))
      drop-shadow(0 -1px 2px rgba(0, 0, 0, 0.1))`,
    m: `
      drop-shadow(0 3px 4px rgba(0, 0, 0, 0.12))
      drop-shadow(0 3px 3px rgba(0, 0, 0, 0.14))
      drop-shadow(0 1px 8px rgba(0, 0, 0, 0.12))
      drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1))`,
  },
  boxShadow: {
    s: "rgba(0, 0, 0, 0.27) 0px 0px 0.25em, rgba(2, 2, 3, 0.05) 0px 0.25em 1em",
    m: "",
  },
  scale: {
    m: 1.2,
  },
  duration: DURATION,
  transition: {
    m: `all ${DURATION}ms ease-out`,
  },
};

// Converts each hex color above to an rgb array (e.g. [r, g, b]) and
// then adds them to the theme object in the color_rgb property.
Object.keys(theme.color).forEach((c: string) => {
  const currcolor = theme.color[c][0];
  theme.color[c] = [];
  theme.color_80[c] = [];
  theme.color_50[c] = [];
  theme.color_30[c] = [];
  theme.color_15[c] = [];
  theme.color_rgb[c] = [];
  theme.color[c].push(hexLum(currcolor, -0.3));
  theme.color[c].push(hexLum(currcolor, -0.15));
  theme.color[c].push(currcolor);
  theme.color[c].push(hexLum(currcolor, 0.15));
  theme.color[c].push(hexLum(currcolor, 0.3));
  theme.color[c].forEach((hex: string) => {
    theme.color_rgb[c].push(hexToRgb(hex));
    theme.color_80[c].push(hexToRgba(hex, 80)); // 80% Opacity
    theme.color_50[c].push(hexToRgba(hex, 50)); // 50% Opacity
    theme.color_30[c].push(hexToRgba(hex, 30)); // 30% Opacity
    theme.color_15[c].push(hexToRgba(hex, 15)); // 15% Opacity
  });
});

// ECharts theming
const contrastColor = theme.color.font[2];
const axisCommon = function () {
  return {
    axisLine: {
      lineStyle: {
        color: contrastColor,
      },
    },
    axisTick: {
      lineStyle: {
        color: contrastColor,
      },
    },
    axisPointer: {
      label: {
        backgroundColor: theme.color_80.main_bg[2],
      },
    },
    axisLabel: {
      textStyle: {
        color: contrastColor,
      },
    },
    splitLine: {
      lineStyle: {
        color: theme.color_15.font[2],
      },
    },
    splitArea: {
      areaStyle: {
        color: contrastColor,
      },
    },
  };
};

echarts.registerTheme("dark_theme", {
  color: theme.echarts_palette,
  backgroundColor: theme.color.panel_bg[2],
  tooltip: {
    backgroundColor: theme.color.main_bg[2],
    axisPointer: {
      lineStyle: {
        color: contrastColor,
      },
      crossStyle: {
        color: contrastColor,
      },
    },
  },
  legend: {
    textStyle: {
      color: contrastColor,
    },
  },
  textStyle: {
    color: contrastColor,
  },
  title: {
    textStyle: {
      color: contrastColor,
    },
  },
  toolbox: {
    iconStyle: {
      normal: {
        borderColor: contrastColor,
      },
    },
  },
  dataZoom: {
    dataBackgroundColor: contrastColor,
    fillerColor: theme.color_15.primary[2],
    handleColor: contrastColor,
    textStyle: {
      color: contrastColor,
    },
  },
  timeline: {
    lineStyle: {
      color: contrastColor,
    },
    itemStyle: {
      normal: {
        color: theme.echarts_palette[1],
      },
    },
    label: {
      normal: {
        textStyle: {
          color: contrastColor,
        },
      },
    },
    controlStyle: {
      normal: {
        color: contrastColor,
        borderColor: contrastColor,
      },
    },
  },
  timeAxis: axisCommon(),
  logAxis: axisCommon(),
  valueAxis: axisCommon(),
  categoryAxis: axisCommon(),

  line: {
    symbol: "circle",
  },
  graph: {
    color: theme.echarts_palette,
  },
  gauge: {
    title: {
      textStyle: {
        color: contrastColor,
      },
    },
  },
  candlestick: {
    itemStyle: {
      normal: {
        color: "#FD1050",
        color0: "#0CF49B",
        borderColor: "#FD1050",
        borderColor0: "#0CF49B",
      },
    },
  },
});

export default theme;
